/**
 * The seeded demo store a theme preview is rendered against by default. It answers under its own
 * slug like any store, so both the storefront (which reads it during a preview) and the admin
 * (which builds preview links to it) name it through this constant rather than spelling the slug
 * twice.
 */
export const DEMO_SHOP_SLUG = 'demo-shop';

/**
 * Which demo store a theme is previewed against, for the themes that do not use the default one.
 * Keyed by theme slug; a theme absent from this map is drawn against `DEMO_SHOP_SLUG`. Empty today:
 * every listed theme is judged against the one demo store, and a theme designed for a catalogue of
 * its own claims it here.
 */
export const THEME_DEMO_SHOPS: Readonly<Record<string, string>> = {};

// Names the demo store a theme is previewed against: its own when it claims one, the default otherwise.
export function demoShopSlug(themeSlug: string | null | undefined): string {
  if (!themeSlug) return DEMO_SHOP_SLUG;
  return THEME_DEMO_SHOPS[themeSlug] ?? DEMO_SHOP_SLUG;
}

// Lists every seeded demo store's slug, the default one first.
export function demoShopSlugs(): readonly string[] {
  return [DEMO_SHOP_SLUG, ...Object.values(THEME_DEMO_SHOPS)];
}

// Reports whether a store slug names a seeded demo store rather than a merchant's own.
export function isDemoShopSlug(slug: string): boolean {
  return demoShopSlugs().includes(slug.trim().toLowerCase());
}
